import { render } from "./exportToCSV.vue?vue&type=template&id=7b37d680"
import script from "./exportToCSV.vue?vue&type=script&lang=js"
export * from "./exportToCSV.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__